import React from 'react';
import {Row, ContenedorForm, HeaderForm, CuerpoForm, TituloForm, ContainerCol } from '../componentes_generales/componentes_formulario/contenedores/';
import { LabelForm } from '../componentes_generales/componentes_formulario/labels/';
import { cargarCatalogosGenericoAsync } from '../../funciones_globales/catalogos';
import moment from 'moment';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { generar_LogAuditoriaIngresoForm, generar_LogAuditoriaSalidaForm } from '../../actions/generales/act_gen03';
import ReactSelectAsync from '../componentes_generales/componentes_formulario/selects/react-select-async';
import { formatearFechaMoment_a_StringFormatoReporte, formatearFechaMoment_a_String } from '../../funciones_globales/format';
import PickerFecha from '../componentes_generales/componentes_formulario/datepicker/datepicker';
import { visualizarReporteEnPdf } from '../../funciones_globales/interaccionApiReportes';
import { getFechaProcesoPorModulo } from '../../funciones_globales/manejosesion';

class FormImpor10  extends React.Component{
    constructor(props){
        super(props);
        this.state = {

            fechaDesde: null,
            fechaHasta: null,
            proveedor_sel: null,
        };

        this.changeComponents = this.changeComponents.bind(this);
        this.limpiar = this.limpiar.bind(this);
        this.impImportacionFobCosto = this.impImportacionFobCosto.bind(this);
    }

    changeComponents(event){
        const target = event.target;       
        const name = target.name; 
        const value = target.type === 'checkbox' ? target.checked : target.value; 
        this.setState({[name]: value});
    }

    getOptions_Proveedores(input, callback){
        if (input.toString().length >= 2 ){
            let cadena_busq = '&cadena_busq=' + input;
            cargarCatalogosGenericoAsync('/proveedores?tipo=catalogo', cadena_busq, callback)
        }
    }

    componentDidMount(){
        Promise.all([
            this.props.generar_LogAuditoriaIngresoForm('0310')
         ])
        .then(() => {

            //Asignacion de Fecha
            let fechaProceso = getFechaProcesoPorModulo('03');
            let fechaHasta = moment(fechaProceso, "DD/MM/YYYY");
            let fechaDesde = moment(fechaProceso, "DD/MM/YYYY");
            this.setState({fechaDesde: fechaDesde, fechaHasta: fechaHasta})
        });
    }

    componentWillUnmount(){
        this.props.generar_LogAuditoriaSalidaForm('0310');
    }

    limpiar(){
        //Asignacion de Fecha
        let fechaProceso = getFechaProcesoPorModulo('03');
        let fechaHasta = moment(fechaProceso, "DD/MM/YYYY");
        let fechaDesde = moment(fechaProceso, "DD/MM/YYYY");
        this.setState({fechaDesde: fechaDesde, fechaHasta: fechaHasta,
        proveedor_sel: null})
    }

    impImportacionFobCosto(){
        var continuar = true;
        var error = "";

        //Que las fechas existan
        if(this.state.fechaDesde !==null && this.state.fechaHasta !==null){

            //Validacion FECHA DESDE > FECHA HASTA
            if(this.state.fechaHasta.diff(this.state.fechaDesde, 'days')<0){
                continuar = false;
                error=error+'- La fecha desde debe ser menor a: '+formatearFechaMoment_a_String(this.state.fechaHasta)+'\n';
            }
        }else{
            continuar = false;
            error=error+'- Debe existir fecha desde y fecha hasta';
        }

        if(continuar === true){
            var parametros = ""

            parametros = '&rpt=52&param1='+formatearFechaMoment_a_StringFormatoReporte(this.state.fechaDesde)+'&param2='+formatearFechaMoment_a_StringFormatoReporte(this.state.fechaHasta)

            if(this.state.proveedor_sel!==null){
                parametros = parametros+'&param3='+this.state.proveedor_sel.value
            }

            visualizarReporteEnPdf(parametros);

        }else{
            alert(error);
        }
    }

    render(){
        return (
            <ContenedorForm porc_ancho={60}>
            <HeaderForm>
                <TituloForm>Importación FOB Costo</TituloForm>
            </HeaderForm>
                <CuerpoForm>
                    <Row>
                        <ContainerCol className='col-sm-8 col-sm-offset-4 col-sm-pull-4'>
                            <Row>
                                <ContainerCol className='col-sm-3' margen_arriba='15' margen_abajo='8'>
                                    <LabelForm>Desde:</LabelForm>
                                </ContainerCol>
                                <ContainerCol className='col-sm-5' margen_arriba='15' margen_abajo='4'>
                                    <PickerFecha fechaSeleccionada={this.state.fechaDesde} func_onChange={(fechaEscogida)=>{this.setState({fechaDesde: fechaEscogida});}}/>
                                </ContainerCol> 
                            </Row>
                            <Row>
                                <ContainerCol className='col-sm-2' margen_abajo='4'>
                                    <LabelForm>Hasta:</LabelForm>
                                </ContainerCol>
                                <ContainerCol className='col-sm-5 col-sm-push-1' margen_abajo='4'>
                                    <PickerFecha fechaSeleccionada={this.state.fechaHasta} func_onChange={(fechaEscogida)=>{this.setState({fechaHasta: fechaEscogida});}}/>
                                </ContainerCol> 
                            </Row>
                            <Row>
                                <ContainerCol className='col-sm-3' margen_abajo='4'>
                                    <LabelForm>Proveedor:</LabelForm>
                                </ContainerCol>
                                <ContainerCol className='col-sm-9' margen_abajo='4'>
                                    <ReactSelectAsync value={this.state.proveedor_sel} func_loadOptions={this.getOptions_Proveedores} func_onChange={(value)=>{this.setState({proveedor_sel: value!==null?value:null})}}/>
                                </ContainerCol>
                            </Row>                            
                        </ContainerCol>
                    </Row>                    
                    <Row>
                        <ContainerCol className='col-sm-12' margen_arriba={10}>
                            <div className='btn-group pull-right'>                                                        
                                <button type='button' className='btn btn-info btn-sm'  onClick={()=>{this.impImportacionFobCosto('PDF')}}><i className="fa fa-print fa-lg" aria-hidden="true"/> Imprimir</button>  
                                <button type="button" className='btn btn-sm'  onClick={this.limpiar}><i className="fa fa-trash-o fa-lg"></i> Limpiar</button>
                            </div>
                        </ContainerCol>
                    </Row>
                </CuerpoForm>
            </ContenedorForm>
        )
    }
}

const mapStateToProps = ((state) => {
    return {puntoFacturacionSel: state.ventas.ptoFacturacionSel, 
            permiso: state.sesion.valoresSesionForm.Permiso,
            usuario: state.sesion.valoresSesionForm.Usuario,
            IdRegAudit: state.sesion.valoresSesionForm.IdRegAudit,}
  });
  
  const mapDispatchToProps = ((dispatch) => {  
    return bindActionCreators({ generar_LogAuditoriaIngresoForm, generar_LogAuditoriaSalidaForm}, dispatch)
  });
  
  export default connect (mapStateToProps, mapDispatchToProps)(FormImpor10);